if (!customElements.get("one-click-subscription-add")) {
  class OneClickSubscriptionAdd extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector(".one-click-subscription-add__form");
      this.submitBtn = this.querySelector(".product-card__atc");

      this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener("submit", this.handleFormSubmit);
      }
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener("submit", this.handleFormSubmit);
      }
    }

    async handleFormSubmit(event) {
      event.preventDefault();

      if (this.submitBtn) {
        this.submitBtn.disabled = true;
        this.submitBtn.classList.add("btn--loading");
      }

      try {
        const formData = new FormData(this.form);
        const item = {
          id: formData.get("id"),
          quantity: 1,
        };

        // The selling plan is server-rendered by the snippet (no picker):
        // this is what makes the add a one-click subscription.
        const sellingPlan = formData.get("selling_plan");
        if (sellingPlan && sellingPlan !== "") {
          item.selling_plan = sellingPlan;
        }

        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== "") properties[match[1]] = value;
        }
        if (Object.keys(properties).length > 0) item.properties = properties;

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [item] }),
        });

        if (response.ok) {
          const addResult = await response.clone().json().catch(() => null);

          try {
            const cartResponse = await fetch(`${FoxTheme.routes.cart_url}`, {
              ...FoxTheme.utils.fetchConfig(),
            });
            const cartJson = await cartResponse.json();
            FoxTheme.pubsub.publish(
              FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              { cart: cartJson }
            );
          } catch (error) {
            console.error("Error fetching cart state:", error);
          }

          const addedLine =
            addResult && (addResult.items ? addResult.items[0] : addResult);
          if (addedLine) {
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                bubbles: true,
                detail: { product: addedLine },
              })
            );
          }

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            document.dispatchEvent(
              new CustomEvent("cart:refresh", {
                detail: { open: true },
              })
            );
          } else {
            window.location.href = "/cart";
          }
        } else {
          console.error("Failed to add product to cart");
          this.form.submit();
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);
        this.form.submit();
      } finally {
        if (this.submitBtn) {
          this.submitBtn.disabled = false;
          this.submitBtn.classList.remove("btn--loading");
        }
      }
    }
  }

  customElements.define("one-click-subscription-add", OneClickSubscriptionAdd);
}
